import { apiClient } from './client';
import { PaginatedResponse } from '../types/pagination';
import { DocumentSend, DocumentSendMethod } from '../types/student';
import { FeeChangeItemInput, FeeChangeRequest, FeeChangeStatus, StudentFeeBreakdown } from '../types/studentFees';

export const getStudentFeeBreakdown = async (studentId: number): Promise<StudentFeeBreakdown> => {
  const { data } = await apiClient.get(`/students/${studentId}/fee-breakdown`);
  return data.data;
};

/** Master Data <-> Payments/Agreement integration fix (Phase 57) — the
 * backend refuses (409) if the student has any approved override; the
 * frontend still shows a confirmation dialog first (§26) since this
 * changes what's payable, even though nothing is silently lost. */
export const syncFeeVersionFromMasterData = async (studentId: number) => {
  const { data } = await apiClient.post(`/students/${studentId}/fee-version/sync`);
  return data.data;
};

export const createFeeChangeRequest = async (
  studentId: number,
  items: FeeChangeItemInput[],
  reason: string,
): Promise<FeeChangeRequest> => {
  const { data } = await apiClient.post(`/students/${studentId}/fee-change-requests`, { items, reason });
  return data.data;
};

export interface ListFeeChangeRequestsParams {
  page: number;
  pageSize: number;
  status?: FeeChangeStatus;
}

export const listFeeChangeRequests = async (
  params: ListFeeChangeRequestsParams,
): Promise<PaginatedResponse<FeeChangeRequest>> => {
  const { data } = await apiClient.get('/students/fee-change-requests', { params });
  return data;
};

export const approveFeeChangeRequest = async (
  id: number,
  remark?: string,
): Promise<{ request: FeeChangeRequest; feeVersion: { id: number; versionNumber: number } }> => {
  const { data } = await apiClient.post(`/students/fee-change-requests/${id}/approve`, { remark });
  return data.data;
};

export const rejectFeeChangeRequest = async (id: number, reason: string): Promise<FeeChangeRequest> => {
  const { data } = await apiClient.post(`/students/fee-change-requests/${id}/reject`, { reason });
  return data.data;
};

export const sendStudentDocument = async (
  documentId: number,
  method: DocumentSendMethod,
  recipient?: string,
  note?: string,
): Promise<DocumentSend> => {
  const { data } = await apiClient.post(`/students/documents/${documentId}/send`, { method, recipient, note });
  return data.data;
};
